import { EllipsisOutlined } from '@ant-design/icons';
import { Dropdown, Button, Menu } from 'antd';

const OssanActionDropdown = ({ actions, triggerIcon = <EllipsisOutlined /> }) => {
    // Crée le menu déroulant à partir des actions
    const menuItems = actions.map(action => ({
        key: action.key,
        label: action.label,
        icon: action.icon,
        onClick: (e) => {
            // S'assure que l'événement de clic sur un élément du menu ne se propage pas
            e.domEvent.stopPropagation();
            action.onClick(e);
        }
    }));

    const menu = <Menu items={menuItems} />;

    return (
        <Dropdown
            overlay={menu}
            trigger={['click']}
            // Ajoutez un gestionnaire d'événement pour le clic de l'icône principale
            onClick={(e) => {
                // S'assure que le clic sur le bouton d'ouverture ne se propage pas
                e.stopPropagation();
            }}
        >
            <Button
                onClick={(e) => {
                    // S'assure que le clic sur le bouton d'ouverture ne se propage pas
                    e.stopPropagation();
                }}
                icon={triggerIcon} />
        </Dropdown>
    );
};

export default OssanActionDropdown;